// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"bf54a971","308":"09f0e606","374":"265a25ce","859":"b8f3a9af"}[chunkId] + ".chunk.js";
};